<template>
    <div>
        <v-card class="">
            <person-courses-table :person-id="personId" />
        </v-card>
    </div>
</template>

<script>
    import PersonCoursesTable from './PersonCoursesTable';

    export default {

        name: "PersonCourse",

        components: {
            PersonCoursesTable
        },

        props: {
            personId: {
                type: Number,
                required: true,
            },
        },

        data: function () {
            return {
                panel: [true]
            }
        },
        mounted() {
        },
    }
</script>

<style scoped>
    #personCourses {
        font-size: 14px;
    }

    .personVehicleTable {
        width: 100%;
        text-align: left;
        padding-left: 16px;
    }
</style>
